module.exports = __webpack_public_path__ + "fa-regular-400.cd0e119ec3bbfb6f902c.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-regular-400.svg
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.svg
// module chunks = styles